import { FormattedMessage, useIntl } from 'react-intl';
import { isValidDate } from './dateHelper';
import { Interval } from 'date-fns';
import { OptionalLabel } from './OptionalLabel';
import { formatInTimeZone } from 'date-fns-tz';

const GMT_FORMAT = 'OOO';
const formatIntervalTimeZone = (interval: Interval, timeZone: string): string => {
    const startTz = isValidDate(interval.start) ? formatInTimeZone(interval.start, timeZone, GMT_FORMAT) : '';
    const endTz = isValidDate(interval.end) ? formatInTimeZone(interval.end, timeZone, GMT_FORMAT) : '';
    return startTz !== endTz ? `${startTz}/${endTz}` : startTz;
};

type LabelWithTimezoneProps = {
    messageId: string;
    isOptional?: boolean;
    timeZoneData: { timeZone: string; date?: Date | number | Interval };
    htmlFor?: string;
};
export const LabelWithTimezone = (props: LabelWithTimezoneProps) => {
    const intl = useIntl();

    let timeZoneString;

    if (props.timeZoneData.date === undefined) {
        return (
            <OptionalLabel isOptional={Boolean(props.isOptional)} htmlFor={props.htmlFor}>
                <FormattedMessage id={props.messageId} />
            </OptionalLabel>
        );
    }
    if (isInterval(props.timeZoneData.date)) {
        timeZoneString = formatIntervalTimeZone(props.timeZoneData.date, props.timeZoneData.timeZone);
    } else {
        timeZoneString = formatInTimeZone(props.timeZoneData.date, props.timeZoneData.timeZone, GMT_FORMAT);
    }
    return (
        <OptionalLabel isOptional={Boolean(props.isOptional)} htmlFor={props.htmlFor}>
            {`${intl.formatMessage({ id: props.messageId })} (${timeZoneString})`}
        </OptionalLabel>
    );
};

const isInterval = (value: Date | number | Interval | undefined): value is Interval => {
    return value !== undefined && typeof value !== 'number' && 'start' in value && 'end' in value;
};
